import { Popover, FloatButton } from "antd";
import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

const InfoButton = () => {
  return (
    <>
      <Popover
        
        placement="left"
        content={
          <div style={{width: 250}}>
            <h3 style={{ textAlign: "center" }}>Baby Name Trends</h3>
            <div>
              Type a name to see its letters grow or shrink with its popularity over time! Choose between France or the U.S., customize colors, tweak stats, and share your unique visual with the world.
            </div>

            <div style={{ marginTop: 16 }}>
              Explore more data-driven designs by <a href="https://bsky.app/profile/karimdouieb.bsky.social" target="_blank" rel="noreferrer">Karim Douieb</a> or visit <a href="https://jetpack.ai" target="_blank" rel="noreferrer">Jetpack.AI</a>.
            </div>

            <div style={{ marginTop: 16 }}>
              Sources: <a href="https://www.ssa.gov/oact/babynames/" target="_blank" rel="noreferrer">USA</a> and <a href="https://www.insee.fr/fr/statistiques/7633685?sommaire=7635552" target="_blank" rel="noreferrer">FR</a>.
            </div>
          </div>
        }
      >
        <FloatButton icon={<InfoCircleOutlined />} />
      </Popover>
    </>
  );
};

export default InfoButton;